export let eco2021_1_58 = {
	"name": "eco2021_1_58",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "К стоимостным формам возмещения вреда относятся:",
				"correct_ans": [
					{
						"ans": "предоставление финансовых средств для восстановления нарушенного состояния ОС до исходного к моменту нанесения вреда уровня",
						"score": 15
					},
					{
						"ans": "финансирование мероприятий по воспроизводству природных ресурсов",
						"score": 15
					},
					{
						"ans": "финансовое обеспечение мер по возмещению вреда, включая упущенную в связи с этим потерпевшей стороной выгоду",
						"score": 15
					},
					{
						"comm": "Все ответы верные, т. к. перечисленные формы, являются стоимостными формами возмещения вреда.",
						"ans": "компенсация дополнительных затрат в связи с восстановлением природного ресурса и народнохозяйственной продукции",
						"score": 15
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 78 ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_20 = {
	"name": "eco2021_1_20",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что относится к функциям государственного управления в области ООС?",
				"correct_ans": [
					{
						"ans": "установление федеральных органов исполнительной власти, осуществляющих государственное управление в области ООС и координация их деятельности",
						"score": 6
					},
					{
						"ans": "разработка и издание соответствующих нормативных правовых документов",
						"score": 6
					},
					{
						"ans": "объявление и установление правового статуса и режима зон экологического бедствия",
						"score": 6
					},
					{
						"ans": "управление природными ресурсами",
						"score": 6
					},
					{
						"ans": "установление порядка осуществления государственного мониторинга ОС",
						"score": 6
					},
					{
						"ans": "экологическое нормирование",
						"score": 5
					},
					{
						"ans": "экологическая экспертиза",
						"score": 5
					},
					{
						"ans": "экологическое лицензирование",
						"score": 5
					},
					{
						"ans": "экологическая сертификация",
						"score": 5
					},
					{
						"ans": "экологический аудит",
						"score": 5
					},
					{
						"comm": "В соответствии с главой II ФЗ об ООС, к функциям государственного управления в области ООС относятся все перечисленные функции.",
						"ans": "экологический контроль",
						"score": 5
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена глава II ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_26 = {
	"name": "eco2021_1_26",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Кем устанавливаются ставки платы и дополнительные коэффициенты за негативное воздействие на ОС?",
				"correct_ans": [
					{
						"ans": "Правительством РФ",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «Государственной Думой РФ» неверный. В соответствии с п. 4 ст. 16. 3 ФЗ об ООС, ставки платы и дополнительные коэффициенты за негативное воздействие на ОС устанавливаются Правительством РФ.",
						"ans": "Государственной Думой РФ",
						"score": 0
					},
					{
						"comm": "Ответ «Правительством субъекта РФ» неверный. В соответствии с п. 4 ст. 16. 3 ФЗ об ООС, ставки платы и дополнительные коэффициенты за негативное воздействие на ОС устанавливаются Правительством РФ.",
						"ans": "Правительством субъекта РФ",
						"score": 0
					},
					{
						"comm": "Ответ «Органами местного самоуправления» неверный. В соответствии с п. 4 ст. 16. 3 ФЗ об ООС, ставки платы и дополнительные коэффициенты за негативное воздействие на ОС устанавливаются Правительством РФ (4. Ставки платы за негативное воздействие на окружающую среду и дополнительные коэффициенты устанавливаются Правительством Российской Федерации. ).",
						"ans": "Органами местного самоуправления",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 4 ст. 16.3 ФЗ об ООС"
}

export let eco2021_1_15 = {
	"name": "eco2021_1_15",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Право природопользования это:",
				"correct_ans": [
					{
						"ans": "это один из институтов экологического права, регулирующий взаимодействие общества с природой",
						"score": 30
					},
					{
						"comm": "Верны оба ответа, т. к. с одной стороны право природопользования это один из институтов экологического права, регулирующий взаимодействие общества с природой, которое выражается в извлечении полезных для человека и общества свойств природной среды для удовлетворения экологических, экономических, культурно-оздоровительных, нравственно-эстетических потребностей, но с другой стороны это субъективное право каждого конкретного природопользователя, вытекающее из конкретного правоотношения.",
						"ans": "это субъективное право конкретного природопользователя",
						"score": 30
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_35 = {
	"name": "eco2021_1_35",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Каковы цели проведения экологической экспертизы?",
				"correct_ans": [
					{
						"ans": "установление соответствия документов, обосновывающих планируемую деятельность требованиям в области ООС",
						"score": 20
					},
					{
						"comm": "Для предупреждения возможных неблагоприятных воздействий этой деятельности на ОС и связанных с ними социальных, экономических и иных последствий.",
						"ans": "определение допустимости реализации объекта экологической экспертизы",
						"score": 20
					},
					{
						"ans": "установление соответствия документов, обосновывающих намечаемую деятельность, экологическим требованиям, установленным техническими регламентами и законодательством в области ООС",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «установления соответствия проводимой хозяйственной и иной деятельности требованиям в области ООС…» неверный, т. к. содержание понятия экологической экспертизы закреплено в ст. 33 ФЗ об ООС и ст. 1 ФЗ от 23. 11. 1995 № 174-ФЗ «Об экологической экспертизе». Определения ЭЭ, закрепленные названными ФЗ, употребляются в отношении к документации намечаемой, а не осуществляемой хозяйственной и иной деятельности.",
						"ans": "установления соответствия проводимой хозяйственной и иной деятельности требованиям в области ООС; и определение допустимости реализации объекта ЭЭ в целях предупреждения возможных неблагоприятных воздействий этой деятельности на ОС и связанных с ними социальных, экономических и иных последствий",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 33 ФЗ об ООС и ст. 1 ФЗ от 23.11.1995 № 174-ФЗ «Об экологической экспертизе»",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_10 = {
	"name": "eco2021_1_10",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что из перечисленного относится к гарантиям обеспечения экологических прав человека:",
				"correct_ans": [
					{
						"ans": "существование законодательно закрепленных экологических норм, неисполнение которых ведет к законодательно закрепленным санкциям",
						"score": 12
					},
					{
						"ans": "независимость средств массовой информации",
						"score": 12
					},
					{
						"ans": "независимость судебной власти",
						"score": 12
					},
					{
						"ans": "государственный контроль за исполнением экологических норм",
						"score": 12
					},
					{
						"comm": "На наш взгляд, здесь уместнее говорить о контроле за исполнением всеми участниками экологических правоотношений норм экологического права, что входит в систему государственных организационно-правовых мер, которые и обеспечивают реализацию экологических прав человека.",
						"ans": "общественный контроль за исполнением экологических норм",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «исполнение всеми участниками экологических правоотношений норм экологического права» неверный, т. к. исполнение норм экологического законодательства – это обязанность всех участников экологических правоотношений, а не мера, которая гарантирует человеку его экологические права.",
						"ans": "исполнение всеми участниками экологических правоотношений норм экологического права",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_159 = {
	"name": "eco2021_1_159",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильное определение животного мира:",
				"correct_ans": [
					{
						"ans": "совокупность живых организмов всех видов диких животных, постоянно или временно населяющих территорию страны и находящихся в состоянии естественной свободы, а также относящихся к природным ресурсам континентального шельфа и исключительной экономической зоны РФ",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «совокупность живых организмов всех видов диких животных, постоянно или временно находящихся на территории страны, а также относящихся к природным ресурсам континентального шельфа и исключительной экономической зоны РФ» неверный. В соответствии со ст. 1 ФЗ о животном мире, он определен как совокупность живых организмов всех видов диких животных, постоянно или временно населяющих территорию страны и находящихся в состоянии естественной свободы, а также относящихся к природным ресурсам континентального шельфа и исключительной экономической зоны РФ.",
						"ans": "совокупность живых организмов всех видов диких животных, постоянно или временно находящихся на территории страны, а также относящихся к природным ресурсам континентального шельфа и исключительной экономической зоны РФ",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ст. 1 ФЗ от 24.04.1995 № 52-ФЗ «О животном мире»"
}

export let eco2021_1_92 = {
	"name": "eco2021_1_92",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Разрешена ли разведка и разработка полезных ископаемых на территориях национальных парков?",
				"correct_ans": [
					{
						"ans": "запрещена разведка и разработка полезных ископаемых",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «разрешена разведка и разработка полезных ископаемых по специальному разрешению» неверный. В соответствии с п. 2 ст. 15 ФЗ об ООПТ разведка и разработка полезных ископаемых запрещена.",
						"ans": "разрешена разведка и разработка полезных ископаемых по специальному разрешению",
						"score": 0
					},
					{
						"comm": "Ответ «разрешена разведка и разработка полезных ископаемых в специальной зоне» неверный. В соответствии с п. 2 ст. 15 ФЗ об ООПТ разведка и разработка полезных ископаемых запрещена.",
						"ans": "разрешена разведка и разработка полезных ископаемых в специальной зоне",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "данному вопросу посвящена ст. 15 Федерального закона от 15.02.95 № 33-ФЗ \"Об особо охраняемых природных территориях\""
}

export let eco2021_1_96 = {
	"name": "eco2021_1_96",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "К какой гражданско-правовой организации относятся национальные парки?",
				"correct_ans": [
					{
						"ans": "к некоммерческим организациям",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «к коммерческим организациям» неверный. В соответствии со ст. 16 ФЗ об ООПТ, национальные парки являются юридическими лицами, которые не имеют в качестве цели своей деятельности извлечение прибыли, то есть являются некоммерческими организациями и создаются в форме природоохранного учреждения, финансируемого за счет средств федерального бюджета.",
						"ans": "к коммерческим организациям",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ст. 16 Федерального закона от 15.02.95 № 33-ФЗ \"Об особо охраняемых природных территориях\""
}

export let eco2021_1_59 = {
	"name": "eco2021_1_59",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "К требованиям в области ООС, предъявляемым к субъектам хозяйственной деятельности, относятся:",
				"correct_ans": [
					{
						"ans": "обеспечение экологической безопасности",
						"score": 10
					},
					{
						"ans": "охрана здоровья населения",
						"score": 10
					},
					{
						"ans": "проведение мероприятий по охране природы",
						"score": 10
					},
					{
						"ans": "проведение мероприятий по рациональному использованию природных ресурсов",
						"score": 10
					},
					{
						"ans": "проведение мероприятий по воспроизводству природных ресурсов",
						"score": 10
					},
					{
						"ans": "проведение мероприятий по оздоровлению ОС",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «проведение мероприятий по озеленению территории вокруг опасного предприятия» неверный, в соответствии с главой VII закона об ООС, к субъектам, осуществляющим хозяйственную и иную деятельность, предъявляются требования по экологической безопасности, по охране здоровья населения, по проведению мероприятий по охране природы; по рациональному использованию и воспроизводству природных ресурсов; по оздоровлению ОС.",
						"ans": "проведение мероприятий по озеленению территории вокруг опасного предприятия",
						"score": 0
					},
					{
						"comm": "Ответ «строительство санаториев и домов отдыха для сотрудников предприятия» неверный, в соответствии с главой VII закона об ООС, к субъектам, осуществляющим хозяйственную и иную деятельность, предъявляются требования по экологической безопасности, по охране здоровья населения, по проведению мероприятий по охране природы; по рациональному использованию и воспроизводству природных ресурсов; по оздоровлению ОС.",
						"ans": "строительство санаториев и домов отдыха для сотрудников предприятия",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена глава VII ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_162 = {
	"name": "eco2021_1_162",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие виды пользования объектов животного мира Вам известны?",
				"correct_ans": [
					{
						"ans": "рыболовство",
						"score": 6
					},
					{
						"ans": "добыча водных беспозвоночных и морских млекопитающих",
						"score": 6
					},
					{
						"ans": "добыча объектов животного мира, не отнесенных к объектам охоты и рыболовства",
						"score": 6
					},
					{
						"comm": "Сюда относятся использование полезных свойств жизнедеятельности объектов животного мира почвообразователей, естественных санитаров окружающей среды, опылителей растений, биофильтраторов и других.",
						"ans": "использование полезных свойств жизнедеятельности объектов животного мира",
						"score": 6
					},
					{
						"ans": "изучение объектов животного мира",
						"score": 6
					},
					{
						"comm": "Исследование объектов ЖМ может проводиться с изъятием и без изъятия их из среды обитания.",
						"ans": "исследование объектов животного мира",
						"score": 5
					},
					{
						"ans": "использование в культурно-просветительных целях",
						"score": 5
					},
					{
						"ans": "использование в рекреационных целях без изъятия их из среды обитания",
						"score": 5
					},
					{
						"ans": "использование в эстетических целях без изъятия их из среды обитания",
						"score": 5
					},
					{
						"ans": "получение продуктов жизнедеятельности объектов животного мира",
						"score": 5
					},
					{
						"comm": "В соответствии со ст. 34 Федерального закона от 24. 04. 1995 № 52-ФЗ «О животном мире» - все ответы верные.",
						"ans": "охота",
						"score": 5
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 34 Федерального закона от 24.04.1995 № 52-ФЗ «О животном мире»",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_51 = {
	"name": "eco2021_1_51",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Понятие экологического правонарушения определяется как:",
				"correct_ans": [
					{
						"ans": "виновное противоправное деяние, нарушающее природоохранное законодательство и причиняющее вред ОС и здоровью человека либо создающее реальную угрозу такого причинения",
						"score": 30
					},
					{
						"comm": "Правильными являются оба ответа.",
						"ans": "виновное противоправное деяние, нарушающее законодательство в области экологии",
						"score": 30
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_129 = {
	"name": "eco2021_1_129",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Могут ли участники простого товарищества быть пользователем недр?",
				"correct_ans": [
					{
						"ans": "да, могут",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «нет, не могут» неверный. В соответствии с ч. 1 ст. 9 Закона о недрах, пользователями недр могут быть субъекты предпринимательской деятельности, в том числе участники простого товарищества, иностранные граждане, юридические лица, если иное не установлено федеральными законами.",
						"ans": "нет, не могут",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ч. 1 ст. 9 Закона о недрах"
}

export let eco2021_1_170 = {
	"name": "eco2021_1_170",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие виды ответственности предусмотрены за нарушение российского законодательства о животном мире?",
				"correct_ans": [
					{
						"comm": "Статья 55 ФЗ от 24. 04. 1995 № 52-ФЗ «О животном мире» устанавливает административную ответственность за нарушение законодательства об использовании и охране животного мира. Примером административной ответственности могут служить ст. 8. 29. , 8. 35. --8. 37. КоАП РФ.",
						"ans": "административная",
						"score": 20
					},
					{
						"comm": "Статья 55 ФЗ от 24. 04. 1995 № 52-ФЗ «О животном мире» устанавливает гражданскую ответственность за нарушение законодательства об использовании и охране животного мира. Примером гражданской ответственности могут служить ст. 1064, 1068 ГК РФ.",
						"ans": "гражданская",
						"score": 20
					},
					{
						"comm": "Статья 55 ФЗ от 24. 04. 1995 № 52-ФЗ «О животном мире» устанавливает уголовную ответственность за нарушение законодательства об использовании и охране животного мира. Примером уголовной ответственности могут служить ст. 256--259 УК РФ.",
						"ans": "уголовная",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «общественная» неверный, т. к. ст. 55 ФЗ от 24. 04. 1995 № 52-ФЗ «О животном мире» устанавливает административную, гражданскую и уголовную ответственность за нарушение законодательства об использовании и охране животного мира.",
						"ans": "общественная",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена глава VIII ФЗ от 24.04.1995 № 52-ФЗ «О животном мире»",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_177 = {
	"name": "eco2021_1_177",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие физические воздействия на атмосферный воздух изменяют его свойства, влияют на окружающую среду и здоровье человека?",
				"correct_ans": [
					{
						"ans": "воздействие шума",
						"score": 15
					},
					{
						"ans": "воздействие вибрации",
						"score": 15
					},
					{
						"ans": "воздействие ионизирующего излучения",
						"score": 15
					},
					{
						"comm": "В соответствии со ст. 1 ФЗ от 04. 05. 1999 № 96-ФЗ «Об охране атмосферного воздуха» - все ответы верные. Вредное физическое воздействие на атмосферный воздух определено как вредное воздействие шума, вибрации, ионизирующего излучения, температурного и других физических факторов, изменяющих температурные, энергетические, волновые, радиационные и другие физические свойства атмосферного воздуха, на здоровье человека и окружающую природную среду.",
						"ans": "воздействие температурного излучения",
						"score": 15
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 1 ФЗ от 04.05.1999 № 96-ФЗ «Об охране атмосферного воздуха»",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_85 = {
	"name": "eco2021_1_85",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Объекты хозяйственной деятельности, негативно воздействующие на ОС, подразделяются на столько категорий:",
				"correct_ans": [
					{
						"ans": "4",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «5» неверный. В соответствии со статьей 4. 2 ФЗ об ООС объекты хозяйственной и иной деятельности, негативно воздействующие на ОС, подразделяются на 4 категории.",
						"ans": "5",
						"score": 0
					},
					{
						"comm": "Ответ «6» неверный. В соответствии со статьей 4. 2 ФЗ об ООС объекты хозяйственной и иной деятельности, негативно воздействующие на ОС, подразделяются на 4 категории.",
						"ans": "6",
						"score": 0
					},
					{
						"comm": "Ответ «3» неверный. В соответствии со статьей 4. 2 ФЗ об ООС объекты хозяйственной и иной деятельности, негативно воздействующие на ОС, подразделяются на 4 категории.",
						"ans": "3",
						"score": 0
					},
					{
						"comm": "Ответ «5» неверный. В соответствии со статьей 4. 2 ФЗ об ООС объекты хозяйственной и иной деятельности, негативно воздействующие на ОС, подразделяются на 4 категории.",
						"ans": "5",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена статья 4.2 ФЗ об ООС"
}

export let eco2021_1_75 = {
	"name": "eco2021_1_75",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "В чьей собственности и в чьем ведении находятся особо охраняемые территории природные федерального значения?",
				"correct_ans": [
					{
						"ans": "в федеральной собственности и находятся в ведении федеральных органов государственной власти",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «в совместной федеральной и субъектов федерации собственности и находятся в ведении органов государственной власти России и субъектов федерации» неверный. В соответствии с п. 6 ст. 2 ФЗ от 15. 02. 95 33-ФЗ № \"Об особо охраняемых природных территориях\", ООПТ могут иметь федеральное, региональное или местное значение. При этом, ООПТ федерального значения являются федеральной собственностью и находятся в ведении федеральных органов государственной власти.",
						"ans": "в совместной федеральной и субъектов федерации собственности и находятся в ведении органов государственной власти России и субъектов федерации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена п. 6 ст. 2 ФЗ от 15.02.95 33-ФЗ № \"Об особо охраняемых природных территориях\""
}

export let eco2021_1_78 = {
	"name": "eco2021_1_78",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "На территории государственного природного заповедника разрешаются деятельность и мероприятия, направленные на?",
				"correct_ans": [
					{
						"ans": "сохранение природных комплексов в естественном состоянии",
						"score": 8
					},
					{
						"ans": "восстановление природных комплексов",
						"score": 8
					},
					{
						"ans": "предотвращение изменений природных комплексов и их компонентов в результате антропогенного воздействия",
						"score": 8
					},
					{
						"comm": "Включая людей и животных природных комплексов и объектов.",
						"ans": "обеспечение санитарной и противопожарной безопасности природных комплексов",
						"score": 8
					},
					{
						"comm": "Таких как нежных лавин, камнепадов, селей и других.",
						"ans": "предотвращение опасных природных явлений угрожающих жизни людей и населенным пунктам",
						"score": 7
					},
					{
						"ans": "проведение научных исследований",
						"score": 7
					},
					{
						"ans": "осуществление экологического мониторинга",
						"score": 7
					},
					{
						"comm": "Все ответы верные, в соответствии со ст. 9 ФЗ от 15. 02. 95 33-ФЗ № \"Об особо охраняемых природных территориях\".",
						"ans": "осуществление контрольных и надзорных функций",
						"score": 7
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 9 ФЗ от 15.02.95 33-ФЗ № \"Об особо охраняемых природных территориях\"",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_1_48 = {
	"name": "eco2021_1_48",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Базовый уровень",
	"data": {
		"questions": [
			{
				"qst": "Как определяется понятие экологического контроля?",
				"correct_ans": [
					{
						"ans": "как система мер, направленная на предотвращение, выявление и пресечение нарушения законодательства в области ООС, обеспечение соблюдения юридическими лицами и индивидуальными предпринимателями требований, в том числе нормативов и нормативных документов, федеральных норм и правил, в области ООС",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «как деятельность правоохранительных органов федерального и регионального уровня государства, направленная на выявление нарушения законодательства в области ООС» неверный. В соответствии со ст. 1 ФЗ об ООС, понятие экологического контроля определено как система мер, направленная на предотвращение, выявление и пресечение нарушения законодательства в области ООС, обеспечение соблюдения субъектами хозяйственной и иной деятельности требований, в том числе нормативов и нормативных документов в области ООС.",
						"ans": "как деятельность правоохранительных органов федерального и регионального уровня государства, направленная на выявление нарушения законодательства в области ООС",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящены ст. 1 и 64 ФЗ от 10.01.2002 № 7-ФЗ «Об охране окружающей среды»"
}

export let eco2021_2_140 = {
	"name": "eco2021_2_140",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что может происходить с отходами после их сбора?",
				"correct_ans": [
					{
						"ans": "использование",
						"score": 15
					},
					{
						"ans": "обезвреживания",
						"score": 15
					},
					{
						"comm": "Ст. 1 ФЗ от 24. 06. 1998 № 89-ФЗ «Об отходах производства и потребления» определяет транспортирование отходов как перемещение их с помощью транспортных средств вне границ земельного участка, находящегося в собственности юрлица или индивидуального предпринимателя либо предоставленного им на иных правах.",
						"ans": "транспортирование",
						"score": 15
					},
					{
						"ans": "размещение",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «эксплуатация» неверный. В соответствии со ст. 1 ФЗ от 24. 06. 1998 № 89-ФЗ «Об отходах производства и потребления», сбор отходов, т. е. их прием или поступление от юридических и физических лиц производится в целях дальнейшего использования, обезвреживания, транспортирования, размещения таких отходов.",
						"ans": "эксплуатация",
						"score": 0
					},
					{
						"comm": "Ответ «складирование» неверный. ФЗ от 24. 06. 1998 № 89-ФЗ «Об отходах производства и потребления» определяет накопление через складирование, т. е. накопление отходов – это временное складирование отходов (на срок не более 6 месяцев) в местах, обустроенных согласно требованиям законодательства в области ООС и санитарно-эпидемиологического благополучия населения, а вопрос посвящен тому, что м. б. сделано с отходами после накопления или складирования.",
						"ans": "складирование",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 1 ФЗ от 24.06.1998 № 89-ФЗ «Об отходах производства и потребления»",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_163 = {
	"name": "eco2021_2_163",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие нормативы выбросов в атмосферный воздух устанавливаются государством?",
				"correct_ans": [
					{
						"comm": "Технические нормативы выбросов устанавливает федеральный орган исполнительной власти в области ООС или другой уполномоченный Правительством РФ федеральный орган исполнительной власти по согласованию с федеральным органом исполнительной власти в области ООС для отдельных видов стационарных источников выбросов вредных веществ в атмосферный воздух, а также для являющихся источниками загрязнения атмосферного воздуха транспортных или иных передвижных средств и установок всех видов.",
						"ans": "технические нормативы выбросов",
						"score": 30
					},
					{
						"comm": "Предельно допустимые выбросы устанавливаются территориальными органами федерального органа исполнительной власти в области ООС для конкретного стационарного источника выбросов вредных веществ в атмосферный воздух и их совокупности (организации в целом). В соответствии с п. 4 ст. 12 ФЗ об охране атмосферного воздуха, в случае невозможности соблюдения юридическими лицами, имеющими источники выбросов загрязняющих веществ в атмосферный воздух, предельно допустимых выбросов территориальные органы федерального органа исполнительной власти в области ООС могут устанавливать для таких источников временно согласованные выбросы по согласованию с территориальными органами других федеральных органов исполнительной власти. Временно согласованные выбросы устанавливаются на период поэтапного достижения предельно допустимых выбросов при условиях соблюдения технических нормативов выбросов и наличия плана уменьшения выбросов вредных (загрязняющих) веществ в атмосферный воздух. При этом, сроки поэтапного достижения предельно допустимых выбросов устанавливаются органами государственной власти субъектов РФ по представлению соответствующих территориальных органов специально уполномоченного федерального органа исполнительной власти в области охраны атмосферного воздуха.",
						"ans": "предельно допустимые выбросы",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «предельно допустимые нормативы вредных физических воздействий» неверный. Поставлен вопрос о выбросах в атмосферный воздух, хотя предельно допустимые нормативы вредных физических воздействий на него тоже устанавливаются государством - ст. 12 ФЗ об охране атмосферного воздуха.",
						"ans": "предельно допустимые нормативы вредных физических воздействий",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 12 ФЗ об охране атмосферного воздуха",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_114 = {
	"name": "eco2021_2_114",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Каковы цели разработки схем комплексного использования и охраны водных объектов?",
				"correct_ans": [
					{
						"ans": "определение допустимой антропогенной нагрузки на водные объекты",
						"score": 15
					},
					{
						"ans": "определение потребностей в водных ресурсах в перспективе",
						"score": 15
					},
					{
						"ans": "обеспечение охраны водных объектов",
						"score": 15
					},
					{
						"ans": "определение основных направлений деятельности по предотвращению негативного воздействия вод",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «выявление лиц, нарушающих водное законодательство» неверный. В соответствии с п. 2. ст. 33 ВК РФ, это не является целью разработки данных схем.",
						"ans": "выявление лиц, нарушающих водное законодательство",
						"score": 0
					},
					{
						"comm": "Ответ «наказание лиц, нарушающих водное законодательство» неверный. В соответствии с п. 2. ст. 33 ВК РФ, это не является целью разработки данных схем.",
						"ans": "наказание лиц, нарушающих водное законодательство",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 33 ВК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_53 = {
	"name": "eco2021_2_53",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие основные функции выполняет юридическая ответственность как институт экологического права?",
				"correct_ans": [
					{
						"comm": "Превентивная функция обеспечивает предупреждение совершения новых правонарушений.",
						"ans": "превентивную",
						"score": 15
					},
					{
						"comm": "Компенсационная функция направлена на возмещение потерь в окружающей среде и возмещение вреда здоровью человека.",
						"ans": "компенсационную",
						"score": 15
					},
					{
						"comm": "Карательная функция заключается в наказании лица, совершившего правонарушение.",
						"ans": "карательную",
						"score": 15
					},
					{
						"comm": "Стимулирующая функция побуждает к соблюдению норм земельного права.",
						"ans": "стимулирующую",
						"score": 15
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_39 = {
	"name": "eco2021_2_39",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Каким документом регулируется порядок осуществления государственного мониторинга земель за исключением земель сельхозназначения?",
				"correct_ans": [
					{
						"ans": "приказом Росреестра от 22.07.2021 № П/0315",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «постановлением Правительства РФ от 24. 12. 2003 № 1645» неверный. Порядок осуществления государственного мониторинга земель регулируется приказом Росреестра от 22. 07. 2021 № П/0315.",
						"ans": "постановлением Правительства РФ от 24.12.2003 № 1645",
						"score": 0
					},
					{
						"comm": "Ответ «приказом Минприроды от 09. 11. 2006 № Пр-4407» неверный. Порядок осуществления государственного мониторинга земель регулируется приказом Росреестра от 22. 07. 2021 № П/0315.",
						"ans": "приказом Минприроды от 09.11.2006 № Пр-4407",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let eco2021_2_221 = {
	"name": "eco2021_2_221",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что является основанием включения объекта, оказывающего негативное воздействие на ОС в государственный реестр?",
				"correct_ans": [
					{
						"ans": "заявка юридического лица, осуществляющего свою деятельность на объекте",
						"score": 20
					},
					{
						"ans": "заявка индивидуального предпринимателя, осуществляющего свою деятельность на объекте",
						"score": 20
					},
					{
						"ans": "запрос Росприроднадзора",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «запрос суда» неверный. В соответствии с Правилами о постановке объекта на государственный учет, основанием для включения опасного для ОС объекта в реестр, является поданная по установленной форме заявка хозяйствующего субъекта или запрос Росприроднадзора.",
						"ans": "запрос суда",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 10 Правил создания и ведения государственного реестра объектов, оказывающих негативное воздействие на ОС, утвержденных постановлением Правительства РФ от 23.06.2016 № 572",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_58 = {
	"name": "eco2021_2_58",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильное определение административного правонарушения в области земельных правоотношений:",
				"correct_ans": [
					{
						"ans": "административным земельным правонарушением признается противоправное, виновное действие (бездействие) физического или юридического лица, посягающее на установленный в России правопорядок, причиняющее вред земле или содержащее угрозу такого причинения, нарушающее нормы природопользования, за которое по Кодексу Российской Федерации об административных правонарушениях или законами субъектов РФ об административных правонарушениях установлена административная ответственность",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неверный. В соответствии со ст. 2. 1. Кодекса Российской Федерации об административных правонарушениях, административным земельным правонарушением признается противоправное, виновное действие (бездействие) физического или юридического лица, посягающее на установленный в России правопорядок, причиняющее вред земле или содержащее угрозу такого причинения, нарушающее нормы природопользования, за которое по Кодексу Российской Федерации об административных правонарушениях или законами субъектов РФ об административных правонарушениях установлена административная ответственность.",
						"ans": "административным земельным правонарушением признается противоправное, виновное действие (бездействие) юридического лица, посягающее на установленный в России правопорядок, причиняющее вред земле или содержащее угрозу такого причинения, нарушающее нормы природопользования, за которое по КоАП РФ установлена административная ответственность",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ст. 2.1. Кодекса Российской Федерации об административных правонарушениях"
}

export let eco2021_2_171 = {
	"name": "eco2021_2_171",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Государственный мониторинг атмосферного воздуха проводится с целью?",
				"correct_ans": [
					{
						"ans": "наблюдения за его загрязнением",
						"score": 15
					},
					{
						"ans": "комплексной оценки его состояния",
						"score": 15
					},
					{
						"ans": "прогноза его состояния",
						"score": 15
					},
					{
						"comm": "Текущей и экстренной информацией о загрязнении атмосферного воздуха обеспечиваются органов государственной власти, органов местного самоуправления, организации и население.",
						"ans": "обеспечения информацией о его состоянии",
						"score": 15
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 23 ФЗ об охране атмосферного воздуха Данному вопросу посвящена глава V ФЗ об охране атмосферного воздуха",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_178 = {
	"name": "eco2021_2_178",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Промышленное внедрение наилучшей доступной технологии на двух и более объектах – один из критериев определения технологии в качестве наилучшей доступной технологии:",
				"correct_ans": [
					{
						"ans": "да, это так",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "В соответствии с п. 4 ст. 28. 1 ФЗ об ООС, промышленное внедрение НДТ на двух и более объектах – это один из главных критериев определения технологии в качестве НДТ, наряду с экономической эффективностью и периодом внедрения НДТ, наименьшим уровнем негативного воздействия на ОС и другими критериями.",
						"ans": "нет, это не так",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 4 ст. 28.1 ФЗ об ООС"
}

export let eco2021_2_165 = {
	"name": "eco2021_2_165",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что устанавливается разрешением на выброс вредных веществ в атмосферный воздух?",
				"correct_ans": [
					{
						"ans": "предельно допустимые выбросы обеспечивающие охрану атмосферного воздуха",
						"score": 30
					},
					{
						"ans": "условия, обеспечивающие охрану атмосферного воздуха",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «условия на вредное физическое воздействие, обеспечивающее охрану атмосферного воздуха» неверный. Вопрос о выбросах вредных веществ. В соответствии с п. 1 ст. 14 ФЗ об охране атмосферного воздуха, разрешением на выброс вредных (загрязняющих) веществ в атмосферный воздух устанавливаются предельно допустимые выбросы и другие условия, которые обеспечивают охрану атмосферного воздуха. Вредные физические воздействия на атмосферный воздух допускаются на основании разрешений, выданных в порядке, определенном Правительством РФ.",
						"ans": "условия на вредное физическое воздействие, обеспечивающее охрану атмосферного воздуха",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 1 ст. 14 ФЗ об охране атмосферного воздуха",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_33 = {
	"name": "eco2021_2_33",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие основные функции выполняет юридическая ответственность как институт экологического права?",
				"correct_ans": [
					{
						"comm": "Превентивная функция обеспечивает предупреждение совершения новых правонарушений.",
						"ans": "превентивную",
						"score": 15
					},
					{
						"comm": "Компенсационная функция направлена на возмещение потерь в окружающей среде и возмещение вреда здоровью человека.",
						"ans": "компенсационную",
						"score": 15
					},
					{
						"comm": "Карательная функция заключается в наказании лица, совершившего правонарушение.",
						"ans": "карательную",
						"score": 15
					},
					{
						"comm": "Ответ «земли континентального шельфа Российской Федерации» неверный. В соответствии со ст. 7 ЗК РФ, в состав земель России данная категория не входит.",
						"ans": "земли континентального шельфа Российской Федерации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 7 ЗК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_213 = {
	"name": "eco2021_2_213",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Что из перечисленного относится к объектам охраны ОС от загрязнения, истощения, деградации, порчи, уничтожения и иного негативного воздействия хозяйственной и/или иной деятельности?",
				"correct_ans": [
					{
						"ans": "природные комплексы",
						"score": 20
					},
					{
						"ans": "компоненты природной среды",
						"score": 20
					},
					{
						"ans": "природные объекты",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «антропогенные объекты» неверный. В соответствии со ст. 4 ФЗ об ООС, к объектам ООС относятся компоненты природной среды, природные объекты и природные комплексы.",
						"ans": "антропогенные объекты",
						"score": 0
					},
					{
						"comm": "Ответ «антропогенные комплексы» неверный. В соответствии со ст. 4 ФЗ об ООС, к объектам ООС относятся компоненты природной среды, природные объекты и природные комплексы.",
						"ans": "антропогенные комплексы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 4 ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_234 = {
	"name": "eco2021_2_234",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "В какой государственный орган подается заявка на получение и переоформление КЭР?",
				"correct_ans": [
					{
						"ans": "в Федеральную службу по надзору в сфере природопользования",
						"score": 30
					},
					{
						"ans": "в Росприроднадзор РФ",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «в Минпромторг России» неверный. В соответствии со ст. 31. 1 ФЗ об ООС и пунктом 5(5)15 Положения о Росприроднадзоре, утвержденного постановлением Правительства РФ от 30. 07. 2004 № 400, названный государственный орган осуществляет прием заявки на получение и переоформление КЭР.",
						"ans": "в Минпромторг России",
						"score": 0
					},
					{
						"comm": "Ответ «в Минприроды РФ» неверный. В соответствии со ст. 31. 1 ФЗ об ООС и пунктом 5(5)15 Положения о Федеральной службе по надзору в сфере природопользования, утвержденного постановлением Правительства РФ от 30. 07. 2004 № 400, названный государственный орган осуществляет прием заявки на получение КЭР.",
						"ans": "в Минприроды РФ",
						"score": 0
					},
					{
						"comm": "Ответ «в Ростехнадзор РФ» неверный. В соответствии со ст. 31. 1 ФЗ об ООС и пунктом 5(5)15 Положения о Федеральной службе по надзору в сфере природопользования, утвержденного постановлением Правительства РФ от 30. 07. 2004 № 400, названный государственный орган осуществляет прием заявки на получение КЭР.",
						"ans": "в Ростехнадзор РФ",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 31.1 ФЗ об ООС, постановление Правительства РФ от 30.07.2004 № 400 и постановление Правительства РФ от 10.11.2020 № 143",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_30 = {
	"name": "eco2021_2_30",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Цели установления публичных сервитутов в соответствии с Земельным кодексом РФ:",
				"correct_ans": [
					{
						"ans": "для прохода или проезда через земельный участок",
						"score": 6
					},
					{
						"ans": "для использования земельного участка в целях ремонта коммунальных, инженерных, электрических и других линий и сетей, а также объектов транспортной инфраструктуры",
						"score": 6
					},
					{
						"ans": "для размещения на земельном участке межевых и геодезических знаков и подъездов к ним",
						"score": 6
					},
					{
						"ans": "для проведения на земельном участке дренажных работ",
						"score": 6
					},
					{
						"ans": "для водопоя и забора воды",
						"score": 6
					},
					{
						"ans": "для прогона скота через земельный участок",
						"score": 5
					},
					{
						"ans": "для сенокоса или пастьбы скота на земельном участке в сроки, продолжительность которых соответствует местным условиям, обычаям, за исключением таких земельных участков в пределах земель лесного фонда",
						"score": 5
					},
					{
						"ans": "для использования земельного участка в целях охоты, ловли рыбы в расположенном на нем замкнутом водоеме",
						"score": 5
					},
					{
						"ans": "для сбора дикорастущих растений в положенные сроки и в установленном порядке",
						"score": 5
					},
					{
						"ans": "для временного пользования земельным участком в целях проведения изыскательских, исследовательских и других работ",
						"score": 5
					},
					{
						"comm": "В соответствии со ст. 23 ЗК РФ – все ответы верные.",
						"ans": "для свободного доступа к прибрежной полосе",
						"score": 5
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 23 Земельного кодекса РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_206 = {
	"name": "eco2021_2_206",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Может ли воздушное пространство являться объектом накопленного вреда?",
				"correct_ans": [
					{
						"ans": "нет, не может",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «да, может» неверный. Статьей 1 ФЗ об ООС объект накопленного вреда ОС определен как территории и акватории, на которых выявлен накопленный вред ОС, объекты капитального строительства и объекты размещения отходов, являющиеся источником накопленного вреда ОС.",
						"ans": "да, может",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ст. 1 ФЗ об ООС"
}

export let eco2021_2_109 = {
	"name": "eco2021_2_109",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие мероприятия проводятся для охраны водосборных площадей водных объектов от загрязнения и засорения?",
				"correct_ans": [
					{
						"ans": "сохранение лесов",
						"score": 8
					},
					{
						"ans": "сохранение болот",
						"score": 8
					},
					{
						"ans": "восстановление лесов",
						"score": 8
					},
					{
						"ans": "восстановление болот",
						"score": 8
					},
					{
						"ans": "закрепление оврагов",
						"score": 7
					},
					{
						"ans": "мелиорация малых рек",
						"score": 7
					},
					{
						"ans": "рекультивация техногенных образований",
						"score": 7
					},
					{
						"comm": "Например, могут быть установлены запреты на размещение на водосборных площадях подземных водных объектов, которые используются для целей питьевого и хозяйственно-бытового водоснабжения, не допускается размещать захоронения отходов производства и потребления, кладбища, скотомогильники и иные объекты, оказывающие негативное воздействие на состояние подземных вод.",
						"ans": "установление запретов",
						"score": 7
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «повышение ставок за водопользование» неверный, в соответствии со ст. 59 ВК РФ, это не относится к мероприятиям по охране водного объекта.",
						"ans": "повышение ставок за водопользование",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "данному вопросу посвящена ст. 59 ВК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_199 = {
	"name": "eco2021_2_199",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Использование наилучших доступных технологий при обращении с отходами – один из принципов государственной политики в данной области:",
				"correct_ans": [
					{
						"ans": "да, это один из принципов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «нет, это не относится к принципам» неверный. В соответствии с п. 1 ст. 3 ФЗ об отходах использование НДТ при обращении с отходами – один из основных принципов государственной политики в данной области.",
						"ans": "нет, это не относится к принципам",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 1 ст. 3 ФЗ об отходах"
}

export let eco2021_2_198 = {
	"name": "eco2021_2_198",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Как осуществляется учет лиц, обязанных вносить плату за негативное воздействие на ОС?",
				"correct_ans": [
					{
						"ans": "при постановке на учет объектов, оказывающих негативное воздействие на ОС",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «при постановке юридического лица на налоговый учет» неверный. В соответствии с п. 2 ст. 16. 1 ФЗ об ООС учет лиц, обязанных вносить плату, к которым относятся юридические лица и индивидуальные предприниматели, осуществляется при ведении государственного учета объектов, оказывающих негативное воздействие на ОС, в соответствии с ФЗ об ООС.",
						"ans": "при постановке юридического лица на налоговый учет",
						"score": 0
					},
					{
						"comm": "Ответ «при получении КЭР» неверный. В соответствии с п. 2 ст. 16. 1 ФЗ об ООС учет лиц, обязанных вносить плату, осуществляется при ведении государственного учета объектов, оказывающих негативное воздействие на ОС, в соответствии с ФЗ об ООС, с учетом того, что при оформлении заявки на получение КЭР, объект, оказывающий негативное воздействие на ОС, должен быть внесен в государственный реестр названных объектов.",
						"ans": "при получении КЭР",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 2 ст. 16.1 ФЗ об ООС"
}

export let eco2021_2_7 = {
	"name": "eco2021_2_7",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "На землях каких категорий могут располагаться лесничества и лесопарки?",
				"correct_ans": [
					{
						"ans": "на землях лесного фонда",
						"score": 15
					},
					{
						"comm": "На тех землях обороны и безопасности, на которых расположены леса.",
						"ans": "на землях обороны и безопасности",
						"score": 15
					},
					{
						"comm": "На тех землях населенных пунктов, на которых расположены леса.",
						"ans": "на землях населенных пунктов",
						"score": 15
					},
					{
						"comm": "На тех землях ООПТ, на которых расположены леса.",
						"ans": "на землях особо охраняемых природных территорий",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «на землях транспорта» неверный. В соответствии со ст. 23 ЛК РФ от 04. 12. 2006 № 200-ФЗ, земли лесного фонда состоят из лесничеств и лесопарков, которые, в свою очередь, также располагаются на землях: обороны и безопасности, на которых расположены леса; населенных пунктов, на которых расположены городские леса; ООПТ, на которых расположены леса.",
						"ans": "на землях транспорта",
						"score": 0
					},
					{
						"comm": "Ответ «на сельскохозяйственных землях» неверный. В соответствии со ст. 23 ЛК РФ от 04. 12. 2006 № 200-ФЗ, земли лесного фонда состоят из лесничеств и лесопарков, которые, в свою очередь, также располагаются на землях: обороны и безопасности, на которых расположены леса; населенных пунктов, на которых расположены городские леса; ООПТ, на которых расположены леса.",
						"ans": "на сельскохозяйственных землях",
						"score": 0
					},
					{
						"comm": "Ответ «на землях, прилегающих к рекам» неверный. В соответствии со ст. 23 ЛК РФ от 04. 12. 2006 № 200-ФЗ, земли лесного фонда состоят из лесничеств и лесопарков, которые, в свою очередь, также располагаются на землях: обороны и безопасности, на которых расположены леса; населенных пунктов, на которых расположены городские леса; ООПТ, на которых расположены леса.",
						"ans": "на землях, прилегающих к рекам",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 23 ЛК РФ от 04.12.2006 № 200-ФЗ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_5 = {
	"name": "eco2021_2_5",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие международные правовые нормы по охране окружающей среды признаются большинством государств в период вооруженных конфликтов?",
				"correct_ans": [
					{
						"ans": "окружающая среда не является законным объектом нападения",
						"score": 15
					},
					{
						"comm": "Не оправданное военной необходимостью разрушение природной среды может быть наказуемо как нарушение международного права установлено п. 1 \"e\" ст. 23 Гаагского положения, ст. 53 IV Женевской конвенции, п. 3 ст. 35 и ст. 55 Протокола I 1977 г.",
						"ans": "не оправданное военной необходимостью разрушение природной среды может быть наказуемо как нарушение международного права",
						"score": 15
					},
					{
						"comm": "При ведении военных действий должна проявляться забота о защите ОС от обширного, долговременного и серьезного ущерба включает запрещение использования методов и средств ведения войны, которые имеют целью причинить или, как можно ожидать, причинят такой ущерб ОС и тем самым нанесут ущерб здоровью и выживанию населения.",
						"ans": "при ведении военных действий должна проявляться забота о защите ОС от обширного, долговременного и серьезного ущерба",
						"score": 15
					},
					{
						"comm": "Запрещение разрушать гражданские объекты за исключением тех случаев, когда такое разрушение оправдано военной необходимостью, обеспечивает защиту и ОС установлено п. 1 \"е\" ст. 23 IV Гаагской конвенции, ст. 53 Женевской конвенции, ст. 52 Протокола I 1977 г. и ст. 13 Протокола II 1977 г.",
						"ans": "запрещение разрушать гражданские объекты за исключением тех случаев, когда такое разрушение оправдано военной необходимостью, обеспечивает защиту и ООС",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "В соответствии с принятыми международными нормами – все ответы верные.",
						"ans": "нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Для ответа на данный вопрос следует изучать международное природоохранное законодательство",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_117 = {
	"name": "eco2021_2_117",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Из чего состоит государственный мониторинг водных объектов?",
				"correct_ans": [
					{
						"comm": "С учетом данных мониторинга, осуществляемого при проведении работ в области гидрометеорологии и смежных с ней областях.",
						"ans": "из мониторинга поверхностных водных объектов",
						"score": 9
					},
					{
						"ans": "из мониторинга состояния дна водных объектов",
						"score": 9
					},
					{
						"ans": "из мониторинга состояния берегов водных объектов",
						"score": 9
					},
					{
						"ans": "из мониторинга состояния водоохранных зон",
						"score": 9
					},
					{
						"comm": "С учетом данных государственного мониторинга состояния недр.",
						"ans": "из мониторинга подземных вод",
						"score": 8
					},
					{
						"comm": "Включая мониторинг гидротехнических сооружений.",
						"ans": "из мониторинга водохозяйственных систем",
						"score": 8
					},
					{
						"comm": "Включая наблюдения за объемом вод при водопотреблении и водоотведении.",
						"ans": "из мониторинга объема вод",
						"score": 8
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящены: п. 5 ст. 30 ВК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_2_80 = {
	"name": "eco2021_2_80",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "С какой целью на землях лечебно-оздоровительных местностей и курортов устанавливаются округа санитарной или горно-санитарной охраны?",
				"correct_ans": [
					{
						"ans": "с целью сохранения благоприятных санитарных и экологических условий для организации профилактики и лечения заболеваний человека",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «с целью запрета приватизации данных земель» неверный. В соответствии со ст. 16 ФЗ от 23. 02. 95 № 26-ФЗ «О природных лечебных ресурсах, лечебно-оздоровительных местностях и курортах» природные лечебные ресурсы, лечебно-оздоровительные местности, а также курорты и их земли являются соответственно особо охраняемыми природными объектами и территориями. Их охрана осуществляется посредством установления округов санитарной (горно-санитарной) охраны.",
						"ans": "с целью запрета приватизации данных земель",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящена ст. 16 ФЗ от 23.02.95 № 26-ФЗ «О природных лечебных ресурсах, лечебно-оздоровительных местностях и курортах»"
}

export let eco2021_2_25 = {
	"name": "eco2021_2_25",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных нормативных правовых актов содержат нормы, закрепляющие право частной собственности на землю?",
				"correct_ans": [
					{
						"comm": "Действительно, гл. 17 ГК РФ посвящена общим положениям о праве собственности на землю.",
						"ans": "Гражданский кодекс РФ",
						"score": 30
					},
					{
						"comm": "ЗК РФ – в главе 3, которая называется «Собственность на землю», закрепляется право частной собственности на землю.",
						"ans": "Земельный кодекс РФ",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «Гражданский процессуальный кодекс РФ» неверный. ГПК РФ не содержит подобных норм, из приведенных ответов, правильными являются – ГК РФ и ЗК РФ.",
						"ans": "Гражданский процессуальный кодекс РФ",
						"score": 0
					},
					{
						"comm": "Ответ «Семейный кодекс РФ» неверный. СК РФ не содержит подобных норм, из приведенных ответов, правильными являются – ГК РФ и ЗК РФ.",
						"ans": "Семейный кодекс РФ",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_27 = {
	"name": "eco2021_3_27",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "В каких формах осуществляется выявление объектов накопленного вреда ОС?",
				"correct_ans": [
					{
						"ans": "в форме инвинтаризации",
						"score": 20
					},
					{
						"ans": "в форме обследования",
						"score": 20
					},
					{
						"comm": "Ответ «в форме сопоставления» неверный. Пункт 1 ст. 80. 1 ФЗ об ООС устанавливает две формы выявления объектов накопленного вреда – обследование и инвинтаризация.",
						"ans": "в форме сопоставления",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «в форме анализа» неверный. Пункт 1 ст. 80. 1 ФЗ об ООС устанавливает две формы выявления объектов накопленного вреда – обследование и инвинтаризация.",
						"ans": "в форме анализа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 1 ст. 80.1 ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_30 = {
	"name": "eco2021_3_30",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Как называется программное компьютерное средство, с помощью которого хозяйствующие субъекты должны передавать заявку и документы на получение КЭР?",
				"correct_ans": [
					{
						"ans": "государственная информационная система промышленности",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «государственный информационный ресурс» неверный. В соответствии с постановлением Правительства РФ от 13. 02. 2019 № 143, утвердившим Правила оформления, переоформления, внесения изменений и др. в КЭР.",
						"ans": "государственный информационный ресурс",
						"score": 0
					},
					{
						"comm": "Ответ «государственный портал информационных услуг» неверный. В соответствии с постановлением Правительства РФ от 13. 02. 2019 № 143, утвердившим Правила оформления, переоформления, внесения изменений и др. в КЭР.",
						"ans": "государственный портал информационных услуг",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящено постановление Правительства РФ от 13.02.2019 № 143, утвердившее Правила оформления, переоформления, внесения изменений и др. в КЭР"
}

export let eco2021_3_47 = {
	"name": "eco2021_3_47",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какой федеральный орган исполнительной власти является уполномоченным органом в сфере промышленной политики?",
				"correct_ans": [
					{
						"ans": "Министерство промышленности и торговли России",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «Министерство экономического развития России» неверный. Постановлением Правительства РФ от 05. 06. 2008 № 438 \"О Министерстве промышленности и торговли Российской Федерации\" утверждено Положение о данном министерстве, которым определены его полномочия. В соответствии с п. 1 названного Положения, Минпромторг РФ является уполномоченным органом РФ в сфере промышленной политики.",
						"ans": "Министерство экономического развития России",
						"score": 0
					},
					{
						"comm": "Ответ «Министерство природных ресурсов и экологии России» неверный. Постановлением Правительства РФ от 05. 06. 2008 № 438 \"О Министерстве промышленности и торговли Российской Федерации\" утверждено Положение о данном министерстве, которым определены его полномочия. В соответствии с п. 1 названного Положения, Минпромторг РФ является уполномоченным органом РФ в сфере промышленной политики.",
						"ans": "Министерство природных ресурсов и экологии России",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящено Постановление Правительства РФ от 05.06.2008 № 438"
}

export let eco2021_3_32 = {
	"name": "eco2021_3_32",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Ведение государственного реестра объектов, оказывающих негативное воздействие на ОС относится к полномочиям:",
				"correct_ans": [
					{
						"ans": "Росприроднадзор",
						"score": 30
					},
					{
						"ans": "территориальные органы Роприроднадзора",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «Минпромторг РФ» неверный. В соответствии с п. 10 Правил создания и ведения государственного реестра объектов, оказывающих негативное воздействие на ОС, утвержденных постановлением Правительства РФ от 23. 06. 2016 № 572, названными полномочиями наделен Росприроднадзор и его территориальные органы.",
						"ans": "Минпромторга РФ",
						"score": 0
					},
					{
						"comm": "Ответ «Роспотребнадзор» неверный. В соответствии с п. 10 Правил создания и ведения государственного реестра объектов, оказывающих негативное воздействие на ОС, утвержденных постановлением Правительства РФ от 23. 06. 2016 № 572, названными полномочиями наделен Росприроднадзор и его территориальные органы.",
						"ans": "Роспотребнадзор",
						"score": 0
					},
					{
						"comm": "Ответ «Росстандарт» неверный. В соответствии с п. 10 Правил создания и ведения государственного реестра объектов, оказывающих негативное воздействие на ОС, утвержденных постановлением Правительства РФ от 23. 06. 2016 № 572, названными полномочиями наделен Росприроднадзор и его территориальные органы.",
						"ans": "Росстандарт",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 10 Правил создания и ведения государственного реестра объектов, оказывающих негативное воздействие на ОС, утвержденных постановлением Правительства РФ от 23.06.2016 № 572",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_13 = {
	"name": "eco2021_3_13",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какая информация содержится в КЭР?",
				"correct_ans": [
					{
						"ans": "технологические нормативы",
						"score": 8
					},
					{
						"ans": "нормативы допустимых выбросов",
						"score": 8
					},
					{
						"comm": "К ним относятся сбросы высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II класса опасности), при наличии таких веществ в выбросах загрязняющих веществ, сбросах загрязняющих веществ.",
						"ans": "нормативы допустимых сбросов",
						"score": 8
					},
					{
						"ans": "нормативы допустимых физических воздействий",
						"score": 8
					},
					{
						"ans": "лимиты на размещение отходов",
						"score": 7
					},
					{
						"ans": "требования к обращению с отходами",
						"score": 7
					},
					{
						"ans": "согласованную программу производственного экологического контроля",
						"score": 7
					},
					{
						"comm": "В соответствии со статьей 31. 1 ФЗ об ООС – все ответы верные.",
						"ans": "срок действия",
						"score": 7
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 10 ст. 31.1 ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_5 = {
	"name": "eco2021_3_5",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Куда подается заявление о включении объекта накопленного вреда ОС в государственный реестр?",
				"correct_ans": [
					{
						"ans": "в Минприроды РФ",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «в Росприроднадзор» неверный. Пунктом 6 Правил ведения государственного реестра объектов накопленного вреда ОС, утвержденных постановлением Правительства РФ от 13. 04. 2017 № 445, закреплено, что заявление о включении объекта в государственный реестр представляется заявителем в письменной форме в Минприроды РФ.",
						"ans": "в Росприроднадзор",
						"score": 0
					},
					{
						"comm": "Ответ «в Минэкономразвития» неверный. Пунктом 6 Правил ведения государственного реестра объектов накопленного вреда ОС, утвержденных постановлением Правительства РФ от 13. 04. 2017 № 445, закреплено, что заявление о включении объекта в государственный реестр представляется заявителем в письменной форме в Минприроды РФ.",
						"ans": "в Минэкономразвития",
						"score": 0
					},
					{
						"comm": "Ответ «в Ростехнадзор» неверный. Пунктом 6 Правил ведения государственного реестра объектов накопленного вреда ОС, утвержденных постановлением Правительства РФ от 13. 04. 2017 № 445, закреплено, что заявление о включении объекта в государственный реестр представляется заявителем в письменной форме в Минприроды РФ.",
						"ans": "в Ростехнадзор",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 6 Правил ведения государственного реестра объектов накопленного вреда ОС, утвержденных постановлением Правительства РФ от 13.04.2017 № 445"
}

export let eco2021_3_10 = {
	"name": "eco2021_3_10",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Какая информация должна содержаться в заявке на получение КЭР юридическим лицом?",
				"correct_ans": [
					{
						"ans": "наименование",
						"score": 3
					},
					{
						"ans": "организационно-правовая форма",
						"score": 3
					},
					{
						"ans": "адрес",
						"score": 3
					},
					{
						"ans": "код объекта, оказывающего негативное воздействие на ОС",
						"score": 3
					},
					{
						"ans": "вид основной деятельности",
						"score": 3
					},
					{
						"ans": "виды производимой продукции",
						"score": 3
					},
					{
						"ans": "объем производимой продукции",
						"score": 3
					},
					{
						"ans": "об использовании сырья",
						"score": 3
					},
					{
						"ans": "об использовании воды",
						"score": 3
					},
					{
						"ans": "об использовании электроэнергии",
						"score": 3
					},
					{
						"ans": "об использовании теплоэнергии",
						"score": 3
					},
					{
						"comm": "Должны быть указаны сведения об авариях, негативно повлиявших на ОС, произошедших за предыдущие семь лет.",
						"ans": "об авариях, негативно повлиявших на ОС",
						"score": 3
					},
					{
						"comm": "При наличии такой программы.",
						"ans": "о реализации программы повышения экологической эффективности",
						"score": 3
					},
					{
						"ans": "расчеты технологических нормативов",
						"score": 3
					},
					{
						"ans": "расчеты нормативов допустимых выбросов",
						"score": 3
					},
					{
						"comm": "К ним, в том числе, относятся нормативы допустимых сбросов радиоактивных, высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II класса опасности), при наличии таких веществ в выбросах, сбросах загрязняющих веществ.",
						"ans": "расчеты допустимых сбросов",
						"score": 3
					},
					{
						"ans": "обоснование нормативов образования отходов",
						"score": 3
					},
					{
						"ans": "обоснование лимитов на размещение отходов",
						"score": 3
					},
					{
						"ans": "проект программы производственного экологического контроля",
						"score": 3
					},
					{
						"comm": "Данная информация должна присутствовать в случае необходимости проведения такой экспертизы в соответствии с законодательством об экологической экспертизе.",
						"ans": "информация о наличии положительного заключения государственной экологической экспертизы",
						"score": 3
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящен п. 3 ст. 31.1 ФЗ об ООС",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_42 = {
	"name": "eco2021_3_42",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Имеет ли право юридическое лицо, ранее получившее КЭР, быть инициатором его пересмотра:",
				"correct_ans": [
					{
						"ans": "да, имеет",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «нет, не имеет» неверный. В соответствии с п. 15 ст. 31. 1 ФЗ об ООС, пересмотр КЭР и внесение в него изменений осуществляются по инициативе юридического лица или индивидуального предпринимателя, получивших КЭР.",
						"ans": "нет, не имеет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 15 ст. 31.1 ФЗ об ООС"
}

export let eco2021_3_28 = {
	"name": "eco2021_3_28",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Лица, осуществляющие свою деятельность в сфере обращения с отходами I - IV класса опасности, обязаны иметь документы о квалификации, выданные по результатам чего?",
				"correct_ans": [
					{
						"ans": "прохождения профессионального обучения",
						"score": 20
					},
					{
						"ans": "прохождения дополнительного образования",
						"score": 20
					},
					{
						"comm": "В соответствии с п. 1 ст. 15 ФЗ об отходах, лица, допущенные к деятельности в сфере обращения с отходами I - IV классов опасности, обязаны иметь документы о квалификации, выданные по результатам прохождения профессионального обучения или получения дополнительного профессионального образования. Все ответы верные.",
						"ans": "получения высшего профессионального образования",
						"score": 20
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Данному вопросу посвящена ст. 15 ФЗ об отходах",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let eco2021_3_35 = {
	"name": "eco2021_3_35",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Продвинутый уровень",
	"data": {
		"questions": [
			{
				"qst": "Кем осуществляется ведение федерального государственного реестра объектов, оказывающих негативное воздействие на ОС?",
				"correct_ans": [
					{
						"ans": "территориальными органами Росприроднадзора по месту нахождения объекта",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ «исполнительными органами государственной власти субъекта РФ» неверный. В соответствии с п. 10 Правил, утвержденных постановлением Правительства РФ от 23. 06. 2016 № 572, Ведение федерального государственного реестра осуществляется территориальными органами Федеральной службы по надзору в сфере природопользования по месту нахождения объектов.",
						"ans": "исполнительными органами государственной власти субъекта РФ",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Данному вопросу посвящен п. 10 Правил, утвержденных постановлением Правительства РФ от 23.06.2016 № 572"
}